module.exports = __webpack_public_path__ + "img/bar_mobile.99fa691f.png";